export default function calculateRoundedPercentages(values) {
  const numericValues = Array.isArray(values)
    ? values.map((value) => parseFloat(value) || 0)
    : [];

  const total = numericValues.reduce((sum, value) => sum + value, 0);
  if (total <= 0) {
    return numericValues.map(() => 0);
  }

  const rawPercentages = numericValues.map((value) => (value / total) * 100);
  const roundedPercentages = rawPercentages.map((value) => Math.floor(value));
  const remainder = 100 - roundedPercentages.reduce((sum, value) => sum + value, 0);

  const rankedFractions = rawPercentages
    .map((value, index) => ({
      index,
      fraction: value - Math.floor(value),
      value,
    }))
    .sort((a, b) => {
      if (b.fraction !== a.fraction) return b.fraction - a.fraction;
      if (b.value !== a.value) return b.value - a.value;
      return a.index - b.index;
    });

  for (let i = 0; i < remainder; i += 1) {
    const target = rankedFractions[i % rankedFractions.length];
    roundedPercentages[target.index] += 1;
  }

  return roundedPercentages;
}
